import { GetterTree } from "vuex";
import { RootState } from "../types";
import { CompanyState } from "./types";

export const getters: GetterTree<CompanyState, RootState> = {};
